import React, { useContext, useEffect, useState } from "react";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { Form, Button, Input, Select, Divider, Space, Tag, Card } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import Mapper from "./DataMapperModal";
import AdvanceDataMapper from "./AdvanceDataMapper";
import { store } from "../../../../../../../redux";
import {
  setAdvancedConfigPanel,
  setDraft,
} from "../../../../../../../redux/actions/skill";
const { Option } = Select;

const ApprovalConfigForm = () => {
  let { selectedNode: node, nodes } = useContext(BuilderContext);
  const { closeDrawer: cancel } = useDrawer();
  const [nodeData, setNodeData] = useState(null);
  let [approvers, setApprovers] = useState([]);
  const [approverValidationStatus, setApproverValidationStatus] =
    useState(null);
  const [approvalMessage, setApprovalMessage] = useState("");
  const [selectedActions, setSelectedActions] = useState({});
  const [actionIds, setActionIds] = useState([]);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  const [form] = Form.useForm();

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  const handleSubmit = async () => {
    try {
      let _validate = await form.validateFields();
      let {
        skillReducer: { trainDraft },
      } = store.getState();
      nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
      nodes = findAndUpdate(nodes, nodeData.id, {
        data: {
          approvers,
          kind: _validate.kind,
          subject: subject,
          body: body,
          actions: Object.keys(selectedActions).filter(
            (i) => selectedActions[i]
          ),
        },
      });
      let _node = nodeData.id.replace("-node-start", "");
      nodes = findAndUpdate(nodes, _node, {
        data: {
          approvers,
          kind: _validate.kind,
          subject: subject,
          body: body,
          actions: Object.keys(selectedActions).filter(
            (i) => selectedActions[i]
          ),
        },
      });
      store.dispatch(
        setDraft({
          ...trainDraft,
          RAW_DATA: {
            ...trainDraft.RAW_DATA,
            actions: nodes,
          },
        })
      );
      cancel();
    } catch (error) {
      console.log("form error", error);
    }
  };

  // useEffect(() => {
  //   setNodeData(node);
  //   setApprovers(node?.data?.approvers || []);
  // }, [node]);

  useEffect(() => {
    setNodeData(node);
    setApprovers(node?.data?.approvers || []);
    if (node && node.data) {
      setSubject(node.data.subject || "");
      setBody(node.data.body || "");
      let obj = {};
      let actions = actionList([], nodes, node.id);
      setActionIds(actions);
      node.data.actions.forEach((i) => {
        obj[i] = true;
      });
      setSelectedActions({ ...obj });
    }
  }, [node]);

  useEffect(() => {
    if (node && nodes && nodes.length > 0) {
      let actions = actionList([], nodes, node.id);
      setActionIds(actions);
    }
  }, [nodes, node]);

  const actionList = (arr, _nodes, id) => {
    for (let item in _nodes) {
      let i = _nodes[item];
      if (i.hasOwnProperty("children")) {
        actionList(arr, i.children, id);
      } else {
        if (i.id == id) {
          return;
        } else {
          arr.push(i);
        }
      }
    }
    return arr;
  };

  const close = (e) => {
    approvers.splice(e, 1);
    setApprovers(approvers);
  };

  const add = async (e) => {
    try {
      let _validate = await form.validateFields();
      approvers.push(_validate.approvers);
      setApprovers([...approvers]);
      form.setFieldValue("approvers", null);
    } catch (e) {}
  };

  const handleChange = async (value) => {
    try {
      let errorEmails = [];
      let _approvers = [];
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      let _validate = await form.validateFields();
      _validate.approvers.forEach((i) => {
        let check = emailRegex.test(i);
        _approvers.push(i);
        setApprovers([..._approvers]);
        form.setFieldValue("approvers", _approvers);
        if (!check) {
          errorEmails.push(i);
        }
      });
      if (Boolean(errorEmails.length)) {
        let msg = `${errorEmails.join(",")} are invalid emails`;
        throw new Error(msg);
      } else {
        setApproverValidationStatus(null);
        setApprovalMessage("");
      }
    } catch (e) {
      setApproverValidationStatus("error");
      setApprovalMessage(e.toString());
    }
  };

  const chooseAction = (i) => {
    let val = Boolean(selectedActions[i]);
    selectedActions[i] = !val;
    setSelectedActions({ ...selectedActions });
  };

  return (
    <div>
      {nodeData ? (
        <div>
          <Form
            form={form}
            layout={"vertical"}
            initialValues={{
              approvers,
              kind: node?.data?.kind,
              subject: node?.data?.subject,
              body: node?.data?.body
            }}
          >
            <Form.Item
              name="approvers"
              label="Add approvers"
              validateStatus={approverValidationStatus}
              help={approvalMessage}
              rules={[
                {
                  required: true,
                  message: "Please add valid email",
                  type: "array",
                },
              ]}
            >
              <Select
                mode="tags"
                placeholder="Add approvers email"
                onChange={handleChange}
              >
                {approvers?.map((i, index) => {
                  return (
                    <Option key={index} value={i}>
                      {i}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>

            <Form.Item name="kind" label="Approval Rule">
              <Select>
                <Select.Option value="serial">
                  Serial Approval
                  <span
                    style={{
                      backgroundColor: "#F0F0F0",
                      fontSize: 11,
                      padding: 5,
                    }}
                  >
                    Approval will be send sequentialy
                  </span>
                </Select.Option>
                <Select.Option value="parallel">
                  Parallel Approval
                  <span
                    style={{
                      backgroundColor: "#F0F0F0",
                      fontSize: 11,
                      padding: 5,
                    }}
                  >
                    Approval will be processed parallely
                  </span>
                </Select.Option>
                <Select.Option value="anyone">
                  Any one Approval
                  <span
                    style={{
                      backgroundColor: "#F0F0F0",
                      fontSize: 11,
                      padding: 5,
                    }}
                  >
                    Single approval will work
                  </span>
                </Select.Option>
              </Select>
            </Form.Item>
          </Form>

          <h6
            style={{
              fontSize: 12,
              fontWeight: 400,
              color: "#5E6C79",
              marginBottom: 10,
            }}
          >
            Choose actions to visualize while approval
          </h6>

          <div
            style={{
              height: 450,
              overflowY: "scroll",
              padding: 20,
              backgroundColor: "#f8f8f8",
            }}
          >
            {actionIds?.map((i, index) => {
              return (
                <div
                  style={{ marginBottom: 15, position: "relative" }}
                  key={index}
                >
                  <Card
                    hoverable={true}
                    bordered={true}
                    style={{ borderRadius: "10px" }}
                    bodyStyle={{ padding: 15 }}
                    onClick={() => chooseAction(i.id)}
                  >
                    {selectedActions[i.id] ? (
                      <CheckCircleTwoTone
                        twoToneColor="#02ce9d"
                        style={{ right: 10, top: 10, position: "absolute" }}
                      />
                    ) : null}
                    <h4 style={{ fontSize: "14px" }}>{i.actionType} </h4>
                    <p
                      style={{
                        marginBottom: "5px",
                        padding: "0",
                        fontWeight: "500",
                        fontSize: "12px",
                      }}
                    >
                      {i.description}
                    </p>
                    <span style={{ fontSize: "12px" }}>{i.id}</span>
                  </Card>
                </div>
              );
            })}
          </div>
          <div>
            <Form.Item
              name="subject"
              label="Email subject"
            >
             <Input defaultValue={subject} onChange={(e) => setSubject(e.target.value)} />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              name="body"
              label="Email body"
            >
               <Input.TextArea defaultValue={body} onChange={(e) => setBody(e.target.value)} />
            </Form.Item>
          </div>

          <div style={{ marginTop: 15 }}>
            <Button onClick={cancel}> Cancel </Button>
            <Button
              type="primary"
              onClick={handleSubmit}
              disabled={approverValidationStatus == "error"}
            >
              Save
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ApprovalConfigForm;
